var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6782 2.6538C11.2228 1.78206 12.7772 1.78207 13.3218 2.65381L16.8421 8.28832C17.3334 9.07473 16.6188 10 15.5202 10H14.8954L17.8105 14.8604C18.4001 15.8434 17.5426 17 16.2243 17H12.75V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V17H7.77573C6.45738 17 5.59993 15.8434 6.18952 14.8604L9.10464 10H8.47977C7.38115 10 6.66661 9.07472 7.15793 8.28832L10.6782 2.6538Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeAlt);
export default __webpack_public_path__ + "static/media/tree-alt.df61f7c98e6783af143ef755ecd9eb3c.svg";
export { ForwardRef as ReactComponent };